<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-tabs content-class="mt-4" nav-class="nav-tabs-custom">
              
              <!-- Company Settings Tab -->
              <b-tab title="Company Settings" active v-if="userData.permissions['view_settings'] == 1">
                <CompanySettings />
              </b-tab>

              <!-- Company Profile Tab -->
              <b-tab title="Company Profile" v-if="userData.permissions['view_company_profile'] == 1">
                <CompanyProfile />
              </b-tab>

              <!-- Financial Years Tab -->
              <b-tab title="Financial Years" v-if="userData.permissions['view_financial_years'] == 1">
                <FinancialYears />
              </b-tab>

              <!-- Payment Options Tab -->
              <b-tab title="Payment Options" v-if="userData.permissions['view_payment_options'] == 1">
                <PaymentOptions />
              </b-tab>

              <!-- Saving Packages Tab -->
              <b-tab title="Saving Packages" v-if="userData.permissions['view_saving_packages'] == 1">
                <SavingPackages />
              </b-tab>

              <!-- Company Documents Tab -->
              <b-tab title="Company Documents" v-if="userData.permissions['view_settings'] == 1">
                <CompanyDocuments />
              </b-tab>

            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

// Import your existing files as components
import CompanySettings from "./companysettings.vue";
import CompanyProfile from "./profile.vue";
import FinancialYears from "./financialyears.vue";
import PaymentOptions from "./paymentoptions.vue";
import SavingPackages from "./savingpackages.vue";
import CompanyDocuments from "./companydocuments.vue";

export default {
  page: {
    title: "General Settings",
  },
  components: {
    Layout,
    PageHeader,
    CompanySettings,
    CompanyProfile,
    FinancialYears,
    PaymentOptions,
    SavingPackages,
    CompanyDocuments
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "General Settings",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "General Settings", active: true },
      ],
    };
  },
};
</script>